import 'magnific-popup'

$(function() {
  $('.js-spMenuBtn').magnificPopup({
    type: 'inline',
    showCloseBtn: false,
    preloader: false,
    fixedContentPos: true,
    alignTop: true,
    callbacks: {
      open() {
        $('body').css('overflow', 'hidden')
        $('body').css('height', '100%')
        $('html').css('height', '100%')
      },
      close() {
        $('body').css('overflow', 'auto')
        $('body').css('height', 'auto')
        $('html').css('height', 'auto')
      }
    }
  })

  $(document).on('click touchend', '.js-spMenuClose', function(e) {
    e.preventDefault()
    $.magnificPopup.close()
  })

  $(window).on('resize', function() {
    if ($('body').css('min-width') == '1060px') {
      if ($('#spMenu').is(':visible')) {
        $.magnificPopup.close()
        $('body').css('overflow', 'auto')
        $('body').css('height', 'auto')
        $('html').css('height', 'auto')
      }
    }
  })
})

// アドレスバー・ツールバーを除いた100vhの値取得（l-gnaviSpのスタイル）
// 関数の定義
function setHeight() {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
// 初期化
setHeight()
// ブラウザのサイズが変更された時・画面の向きを変えた時に再計算する
window.addEventListener('resize', setHeight)
